
(function () {
    'use strict';

    angular
        .module('ib-seat-map-module')
        .directive('ibFlightMapHover', ibFlightMapHover);

    ibFlightMapHover.$inject = [];
    function ibFlightMapHover () {

        return {
            restrict: 'A',
            link: link
        };

        function link (scope, element, attrs) {

            let actualClassName,
                oldClassName,
                oldClassLegend,
                actualClassLegend,
                findData,
                hoverClass;


            // MOUSEOVER
            //////////////

            angular.element(element).find('ul').mouseover(function (e) {

                let findAll = false;
                let findClassName,
                    findClassNameTwo = '',
                    findClassNameThree = '',
                    state;

                // Extrae el tipo de asiento sobre el que se hace hover en la leyenda
                state = angular.element(e.target).data('hover');

                // Si ha sido sobre los asientos
                if (!state) {
                    hoverClass = angular.element(this).find('li').attr('class');
                    const parts = hoverClass.split('ib-map__column--');
                    state = parts[parts.length - 1].trim();
                }

                switch (state) {
                        case 'free':
                        case 'occupied':
                        case 'wing-left':
                        case 'standard':
                            actualClassName = 'ib-map__row-hover--standard';
                            findClassName = 'ib-map__column--free';
                            findClassNameTwo = 'ib-map__column--occupied';
                            findClassNameThree = 'ib-map__column--wing-left';
                            actualClassLegend = 'ib-map-seats__leyend-list-hover--standard';
                            findData = 'standard';
                            findAll = true;
                            break;
                        case 'emergency':
                            actualClassName = 'ib-map__row-hover--emergency';
                            findClassName = 'ib-map__column--emergency';
                            actualClassLegend = 'ib-map-seats__leyend-list-hover--emergency';
                            findData = 'emergency';
                            break;
                        case 'comfort':
                            actualClassName = 'ib-map__row-hover--comfort';
                            findClassName = 'ib-map__column--comfort';
                            actualClassLegend = 'ib-map-seats__leyend-list-hover--comfort';
                            findData = 'comfort';
                            break;
                        case 'promo':
                            actualClassName = 'ib-map__row-hover--promo';
                            findClassName = 'ib-map__column--promo';
                            actualClassLegend = 'ib-map-seats__leyend-list-hover--promo';
                            findData = 'promo';
                            break;
                        case 'upfront':
                            actualClassName = 'ib-map__row-hover--upfront';
                            findClassName = 'ib-map__column--upfront';
                            actualClassLegend = 'ib-map-seats__leyend-list-hover--upfront';
                            findData = 'upfront';
                            break;
                        default:
                            findData = null;
                            actualClassName = null;
                            findClassName = null;
                            actualClassLegend = null;
                            break;
                }

                // Elimina las clases aplicadas en asientos
                angular.element('[class*="ib-map__row"]').removeClass(oldClassName);

                // Aplica las clas clases a las filas correspondientes
                if (actualClassName) {
                    angular.element('[class*="' + findClassName + '"]').parent('ul').addClass(actualClassName);
                }

                // Aplico la clase standard a tipo free|occupied|wing-left
                if (findAll) {
                    angular.element('[class*="' + findClassNameTwo + '"]').parent('ul').addClass(actualClassName);
                    angular.element('[class*="' + findClassNameThree + '"]').parent('ul').addClass(actualClassName);
                }

                // Clase actual aplicada pasa a clase antigua
                oldClassName = actualClassName;

                // Elimina las clases aplicadas en leyenda
                angular.element('[class*="ib-map-seats__leyend-list__item"]').removeClass(oldClassLegend);

                // Aplico la clase al elemento en la leyenda
                if (actualClassLegend) {
                    angular.element('[data-hover=' + findData + ']').addClass(actualClassLegend);
                }

                // Clase de leyenda actual pasa a clase de leyenda antigua
                oldClassLegend = actualClassLegend;
            });


            // MOUSEOUT
            /////////////

            angular.element(element).mouseout(() => {
                angular.element('[class*="ib-map__row"]').removeClass(oldClassName);
                angular.element('[class*="' + oldClassLegend + '"]').removeClass(oldClassLegend);
            });

        }
    }
})();
